// 登录成功以目标页面完成导航为准；不改动认证、菜单或全局路由守卫。
// 首次菜单 bootstrap 会把原 replace 转成同目标重定向，不能仅等待它的 Promise。
const pendingNavigations = new WeakMap();

function isNavigationFailure(value) {
  return Boolean(value && value._isRouter === true);
}

function navigateAfterLogin(router, location, options = {}) {
  const previous = pendingNavigations.get(router);
  if (previous) previous();

  return new Promise((resolve, reject) => {
    let settled = false;
    let removeAfterEach;
    let timer;
    const expected = router.resolve(location).route;
    const expectedPath = expected.fullPath;
    const finish = (completed, error) => {
      if (settled) return;
      settled = true;
      // VueRouter 逐项遍历 afterHooks；延后一微任务卸载，避免跳过后注册的业务 hook。
      if (removeAfterEach) Promise.resolve().then(removeAfterEach);
      clearTimeout(timer);
      if (pendingNavigations.get(router) === cancel) pendingNavigations.delete(router);
      if (error) reject(error);
      else resolve(completed);
    };
    const cancel = () => finish(false);
    const handleFailure = (error) => {
      if (isNavigationFailure(error)) {
        // redirected=2：菜单守卫会重入同一地址，继续等最终 afterEach。
        if (error.type !== 2) finish(false);
      } else if (error) {
        finish(false, error);
      }
    };

    pendingNavigations.set(router, cancel);
    removeAfterEach = router.afterEach((to) => {
      // 认证/权限守卫改去其他页面或落到未匹配路由时，均不能声称登录完成。
      finish(Boolean(to && to.fullPath === expectedPath && to.matched && to.matched.length));
    });
    const timeoutMs = Number.isFinite(options.timeoutMs) && options.timeoutMs >= 0 ? options.timeoutMs : 15000;
    timer = setTimeout(cancel, timeoutMs);
    try {
      // 本项目的 replace 会把已知路由失败转为 resolved Error，成功分支也须检查。
      Promise.resolve(router.replace(location)).then(handleFailure, handleFailure);
    } catch (error) {
      finish(false, error);
    }
  });
}

module.exports = { navigateAfterLogin };
